import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../../base/BaseComponent";
import {DatePicker, Button, Dropdown, Icon, Menu} from 'antd';
import {formatMediaDate} from "../../../../../../utils";
import moment from 'moment';


export default class FileTime extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            start:"",
            end:""
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    onChange(type, date, dateString) {
        if(date){
            let time = date.valueOf();
            this.state[type] = time;
        }else{
            this.state[type] = '';
        }
        this.setState({})
    }

    onOk = () => {
        let start = this.state.start;
        let end = this.state.end;
        if (typeof this.props.onClickCall == "function") {
            this.props.onClickCall([{type:"startDate", data:start},{type:"endDate", data:end}]);
        }
    };

    render() {
        //时间
        let time;
        if (this.state.start || this.state.end) {
            if (this.state.start && !this.state.end) {
                time = moment(this.state.start).format('YYYY-MM-DD') + "~至今"
            } else if (!this.state.start && this.state.end) {
                time ='以前~'+ moment(this.state.end).format('YYYY-MM-DD')
            } else {
                time = moment(this.state.start).format('YYYY-MM-DD') + "~" + moment(this.state.end).format('YYYY-MM-DD')
            }
        } else {
            time = '时间不限'
        }
        return (
            <Dropdown overlay={this.renderMenu()} trigger={["click"]} style={{display: 'none'}}>
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}
                   style={{color: 'rgba(0, 0, 0, 0.65)', fontSize: '14px', marginRight: "32px"}}
                >
                    {time}&nbsp;&nbsp;
                    <Icon type="down"/>
                </a>
            </Dropdown>
        )
    }

    renderMenu=()=> {
        return (
            <Menu
                onClick={()=>{this.setState({})}}
                ref={ref=>this.menu=ref}
                style={{padding: '16px',fontSize: '12px',background:'#ffffff',marginTop:'7px'}}>
                <div style={{marginBottom:'10px'}}>
                    <span style={{color: "rgba(0, 0, 0, 0.65)"}}>从：</span>
                    <DatePicker
                        placeholder="开始时间"
                        style={{width: '120px'}}
                        allowClear={true}
                        showToday={false}
                        value={this.state.start ? moment(this.state.start) : null}
                        onChange={(date, dateString) => {
                            let newDate=date;
                            if(newDate) {
                                newDate=moment(date).startOf("day");
                            }
                            this.onChange("end", null, dateString)
                            this.onChange("start", newDate, dateString)
                        }}
                    />
                </div>
                <div>
                    <span style={{color: "rgba(0, 0, 0, 0.65)"}}>至：</span>
                    <DatePicker
                        placeholder="结束时间"
                        style={{width: '120px'}}
                        allowClear={true}
                        showToday={false}
                        value={this.state.end ? moment(this.state.end) : null}
                        disabledDate={(current)=>{
                            //可以起始都是当前天
                            return current && current < moment(this.state['start']-86400000).endOf('day');
                        }}
                        onChange={(date, dateString) => {
                            let newDate=date;
                            if(newDate) {
                                newDate=moment(date).endOf("day");
                            }
                            this.onChange("end", newDate, dateString)
                        }}
                    />
                </div>
                <div style={{borderTop:'1px solid rgba(240, 240, 240, 1)',marginTop:'16px',display:'flex',justifyContent:'flex-end' }}>
                    <Button type="primary"
                            style={{
                                width: '44px', height: '24px', background: 'rgba(0, 80, 179, 1)',
                                color: 'rgba(255, 255, 255, 1)', fontSize: '12px', padding: '0', marginTop: '10px'
                            }}
                            onClick={() => {
                                this.state.start ='';
                                this.state.end = '';
                                this.setState({},()=>{
                                    this.onOk();
                                    this.menu.props.onClick();
                                })
                            }}
                    >重置</Button>
                    <Button type="primary" style={{width:'44px',height:'24px',background:'rgba(0, 80, 179, 1)',marginLeft:10,
                        color:'rgba(255, 255, 255, 1)',fontSize:'12px',padding:'0',marginTop:'10px' }}
                            onClick={()=>{
                                this.onOk();
                                this.menu.props.onClick();
                            }}>确定</Button>
                </div>
            </Menu>

        )
    }

}